<template>
    <div class="breadcrumb-sold-container" :class="theme">
        <div class="breadcrumb-bar f-col">
            <!-- <span class="fack-link"> Home </span>
            <span class="arrow" v-if="state"> &gt; </span>-->
            <div class="left">
                <span class="fack-link" v-if="state">{{ state }}</span>
                <span class="arrow" v-if="city && state">&gt;</span>
                <a
                    class="link"
                    v-if="city && state && !isHESite"
                    :href="cityLink"
                    rel="noopener noreferrer"
                >
                    {{ city }}
                </a>
                <span class="fack-link" v-if="city && state && isHESite">{{
                    city
                }}</span>

                <span class="arrow" v-if="subdivision && city && state"
                >&gt;</span
                >
                <a
                    class="link"
                    v-if="subdivision && city && state && !isHESite"
                    :href="sbdvLink"
                    rel="noopener noreferrer"
                >{{ subdivision }}</a
                >
                <span
                    class="fack-link"
                    v-if="subdivision && city && state && isHESite"
                >{{ subdivision }}</span
                >
                <template v-if="buildingInfo && buildingInfo.value">
                    <span class="arrow">&gt;</span>
                    <a
                        class="link"
                        :href="buildingInfo.value"
                        rel="noopener noreferrer"
                    >
                        {{ buildingInfo.extraArg }}
                    </a>
                </template>
            </div>
            <div class="back right" v-if="hasBack" @click="backHandler">
                <i class="iconfont" :class="iconStyle"></i>
                <span>{{ backLinkText }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { usePageStore } from '@/store';
import { buildUrl } from '@/router/index.js';
const BUILDING_LISTING_GROUPID = 2;
const BUILDING_FIELDID = 199;
export default {
    i18next: {
        ns: 'md-detail-info'
    },
    props: ['detailInfo', 'theme', 'back', 'backText'],
    data: function() {
        return {
            hasBack: this.back || false,
            backLinkText:
                this.backText || this.$t('md-sold-info.backToResults')
        };
    },
    computed: {
        ...rootMapState(usePageStore, {
            'siteType': store => store.page?.siteType,
            'page': store => store.page,
            currencyAbbr: store => store.currency.abbr,
        }),
        ...mapState({
            'listingGroups': store => store.listingDetail.listingGroups || []
        }),
        isHESite() {
            return this.siteType == 4;
        },
        city() {
            return (this.detailInfo.city || '').replace(/\//g, '-');
        },
        state() {
            return (this.detailInfo.state || '').replace(/\//g, '-');
        },
        subdivision() {
            return (
                (!/null|undefined/gi.test(this.detailInfo.subDivisionName) &&
                    this.detailInfo.subDivisionName) ||
                ''
            ).replace(/\//g, '-');
        },
        cityLink({ city, state, page }) {
            if (page['FEATURE_AREA_VERSION']) {
                return `/area/${city.toLowerCase()}-${state}/listings`.replaceAll(' ', '-')
            }
            return buildUrl({
                name: 'sold-detail',
                params: {
                    id: state,
                    address: city
                }
            }).replace(
                /[^a-zA-Z0-9,/]+/g,
                '-'
            );
        },
        sbdvLink({ city, state, page, subdivision }) {
            if (page['FEATURE_AREA_VERSION']) {
                return `/area/${city.toLowerCase()}-${state}/${subdivision}/listings`.replaceAll(' ', '-')
            }
            return buildUrl({
                name: 'sold-detail',
                params: {
                    id: state,
                    address: `${subdivision},${city}`
                }
            }).replace(
                /[^a-zA-Z0-9,/]+/g,
                '-'
            );
        },
        iconStyle() {
            const iconMap = {
                classic: 'icon-v2-arrow',
                standard: 'icon-v3-arrow',
                fashion: 'icon-v4-arrow',
                broker: 'icon-arrow'
            };
            return iconMap[this.theme];
        },
        buildingInfo() {
            //  judge whether there is buildingName
            const target = this.listingGroups.find(
                it => it.id == BUILDING_LISTING_GROUPID
            );
            if (target && target.fields) {
                const targetField = target.fields.find(
                    item => item.id == BUILDING_FIELDID
                );
                return targetField;
            }
            return null;
        }
    },
    methods: {
        backHandler() {
            window.history.back();
        }
    },
    mounted() {
        // const fromPage = getQueryField('fromPage');
    }
};
</script>
<style lang="scss">
.breadcrumb-sold-container {
    height: 44px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .breadcrumb-bar {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    &.classic {
        background: #f2f2f2;
        .breadcrumb-bar.f-col {
            .link,
            .fack-link,
            .arrow {
                color: var(--color-label);
            }
        }
    }
    &.standard {
        background: #eeeff5;
        .breadcrumb-bar.f-col {
            .link,
            .fack-link,
            .arrow {
                color: var(--color-label);
            }
        }
    }
    &.broker {
        background: rgba(0, 0, 0, 0.03);

        .breadcrumb-bar.f-col {
            .fack-link,
            .arrow {
                color: #505050;
            }
            .link {
                color: #000;
            }
            .face-link,
            .arrow,
            .link {
                font-size: 14px;
            }
        }
    }
    &.fashion {
        background: #2f374f;
        .breadcrumb-bar.f-col {
            .link,
            .fack-link,
            .arrow {
                color: #bfc9e4;
            }
        }
    }
    .breadcrumb-bar.f-col {
        .link,
        .fack-link {
            color: var(--color-text);
            font-size: 12px;
        }
        .link {
            cursor: pointer;
            text-decoration: underline;
        }
        .arrow {
            cursor: pointer;
            font-size: 10px;
            margin: 0 3px;
        }
        .link:hover {
            cursor: pointer;
            color: var(--color-theme);
            font-family: var(--font-medium);
        }
        .back {
            position: relative;
            display: flex;
            flex-direction: row;
            align-items: center;
        }
    }
}
</style>
